/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Media_Import_SuccessInputs */

const en_new_project_media_import_success = /** @type {(inputs: New_Project_Media_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media import completed successfully.`)
};

const fr_new_project_media_import_success = /** @type {(inputs: New_Project_Media_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation du media terminee avec succes.`)
};

const de_new_project_media_import_success = /** @type {(inputs: New_Project_Media_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medienimport erfolgreich abgeschlossen.`)
};

const it_new_project_media_import_success = /** @type {(inputs: New_Project_Media_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione dei media completata con successo.`)
};

const ru_new_project_media_import_success = /** @type {(inputs: New_Project_Media_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт медиафайлов успешно завершен.`)
};

const es_new_project_media_import_success = /** @type {(inputs: New_Project_Media_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La importación de medios se completó correctamente.`)
};

const zh_cn2_new_project_media_import_success = /** @type {(inputs: New_Project_Media_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒体导入成功完成。`)
};

const ja_new_project_media_import_success = /** @type {(inputs: New_Project_Media_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアのインポートが正常に完了しました。`)
};

const hi_new_project_media_import_success = /** @type {(inputs: New_Project_Media_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया का आयात सफलतापूर्वक पूरा हो गया।`)
};

const pt_pt2_new_project_media_import_success = /** @type {(inputs: New_Project_Media_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação de mídia concluída com sucesso.`)
};

/**
* | output |
* | --- |
* | "Media import completed successfully." |
*
* @param {New_Project_Media_Import_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_media_import_success = /** @type {((inputs?: New_Project_Media_Import_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Media_Import_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_media_import_success(inputs)
	if (locale === "de") return de_new_project_media_import_success(inputs)
	if (locale === "it") return it_new_project_media_import_success(inputs)
	if (locale === "ru") return ru_new_project_media_import_success(inputs)
	if (locale === "es") return es_new_project_media_import_success(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_media_import_success(inputs)
	if (locale === "ja") return ja_new_project_media_import_success(inputs)
	if (locale === "hi") return hi_new_project_media_import_success(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_media_import_success(inputs)
	return en_new_project_media_import_success(inputs)
});